import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component, computed,
  input
} from '@angular/core';
import { PlayerController } from '@splixer/player';
import {
  faCirclePlay,
  faCirclePause,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faAnglesLeft,
  faAnglesRight,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faForwardStep,
  faBackwardStep,
} from '@fortawesome/pro-solid-svg-icons';
import { NgStyle } from '@angular/common';
import {
  FaDuotoneIconComponent,
  FaIconComponent,
} from '@fortawesome/angular-fontawesome';
import { SecondsToMinutesPipe } from '@hidat/ng-common';

@Component({
  selector: 'pv2-player',
  templateUrl: 'v2-player.component.html',
  styleUrl: 'v2-player.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgStyle,
    FaIconComponent,
    FaDuotoneIconComponent,
    SecondsToMinutesPipe,
  ],
})
export class PV2PlayerComponent extends PlayerController {
  public canScrub = input(true, { transform: booleanAttribute });
  public canScrubBack = input(true, { transform: booleanAttribute });
  public canSkip = input(true, { transform: booleanAttribute });

  protected playIcon = faCirclePlay;
  protected pauseIcon = faCirclePause;
  protected backIcon = faAnglesLeft;
  protected forwardIcon = faAnglesRight;
  protected skipForwardIcon = faForwardStep;
  protected skipBackIcon = faBackwardStep;

  protected positionSpoken = computed(() => {
    const p = this.positionSeconds();
    const pm = this.positionMinutes();
    const dm = this.durationMinutes();
    let speech: string | undefined;
    if (dm > 0) {
      if (p === 0) {
        speech = `At the start of ${dm} minutes`;
      } else if (p < 60) {
        speech = `At ${p} seconds of ${dm} minutes`;
      } else {
        speech = `At minute ${pm} of ${dm} minutes`;
      }
    } else {
      speech = 'No Audio'
    }
    return speech;
  })

  public startOver = () => {
    this.playerEngine.setPosition(0);
  };

  public skip = () => {
    /*if (this.session.canSkip()) {*/
    this.playbackService.skipSegment();
  };
}
